module.exports = __webpack_public_path__ + "static/img/29.6615ec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/29.jpg
// module id = JCTf
// module chunks = 0